export default {
  hsk_left_time: 'Time remaining',
  hsk_submit_paper: 'Submit paper',
  hsk_rotate_device_title: 'Please rotate your device to landscape',
  hsk_rotate_device_desc: 'For the best test experience',
  hsk_not_finished: 'Not finished',
  hsk_not_start: 'Not started',
  hsk_finished: 'Completed',
  hsk_if_test: 'You did not finish your last paper. Continue?',
  hsk_progress_lost_restart: 'Your previous answers could not be found. This test will start from the first question.',
  hsk_exam_data_error: 'There is an issue with the test data. Please go back and try again.',
  hsk_start_again: 'Restart',
  hsk_go_on: 'Continue',
  hsk_if_save: 'Quit? Your answers will be saved so you can continue next time.',
  hsk_login_filed: 'Your login information has expired, and we will not keep your answer record.',
  hsk_report: 'Results',
  hsk_point: 'points',
  hsk_qualified_point: 'Pass mark: {points}',
  hsk_part1: 'Part {part}',
  hsk_accuracy1: 'Correct',
  hsk_test_again: 'Test again',
  hsk_example: 'Example',
  hsk_example_eg: 'Ex.',
  hsk_answer_analysis: 'Correct answer:',
  hsk_your_answer: 'Your answer:',
  hsk_audio_text: 'Audio:',
  hsk_correct_answer: 'Correct answer:',
  hsk_listen_name: 'Listening',
  hskk_listen_name: 'Speaker and Microphone Testing',
  hsk_read_name: 'Reading',
  hsk_write_name: 'Writing',
  hsk_reference_answer: 'Example:',
  hsk_question_audio_content: 'Question audio content:',
  hsk_reference_answer_hskk: 'Question audio content:',
  hsk_submit_msg: 'Submit your answers?',
  hsk_homework_no_answer: 'Not answered',
  hsk_practice_sava: 'Quit? Your answers will not be saved.',
  hsk_practice_go: 'Try it',
  hsk_practice_part: 'Section',
  hsk_practice_operate: 'Actions',
  hsk_practice_check: 'View',
  hsk_practice_num1: 'Correct',
  hsk_practice_num2: 'out of {totalNum} questions in total',
  hsk_preview_listen_msg:
    'Whilst the introductory audio is playing, you may preview the questions in the listening section.',
  hsk_preview_listen_prompt:
    'Whilst the introductory audio is playing, you may preview the questions in the listening section.  Please do not refresh or close the page during the test, otherwise the answer data will be lost.',
  hsk_enter_next_segment_msg: 'Proceed to the next section?',
  hsk_enter_next_segment_preview:
    'End the preview now? When the preview time has ended, your listening test will begin.',
  hsk_enter_next_segment_listen_tip: 'You have {count} listening questions to answer.',
  hsk_enter_next_segment_listen:
    'Do you want to start your review of your answers to the questions in the listening section?',
  hsk_enter_next_segment_listen_review_start:
    'You now have {count} minutes to review your answers to the questions in the listening section.',
  hsk_enter_next_segment_listen_review:
    'Are you sure you want to end your review? Once you end your review, the listening section will end and you will not be able to return to it again.',
  hsk_enter_next_segment_read_tip: 'You now have {count} reading questions to answer.',
  hsk_enter_next_segment_read:
    'Are you sure to you want to submit your answers to the questions in the reading section? Once submitted, the reading section will end and you will not be able to return to it again.',
  hsk_enter_next_segment_write_tip: 'You now have {count} writing questions to answer.',
  hsk_enter_next_segment_write: 'Are you sure you want to submit your test paper?',
  hsk_end_preview: 'End preview',
  hsk_submit_listen: 'Submit listening',
  hsk_end_review: 'End review',
  hsk_start_exam: 'Start',
  hsk_start_exam_new: 'Start',
  hsk_link_test: 'Real past papers',
  hsk_link_tips: 'Do a real past paper and get an official certificate',
  hsk_buy: 'Buy',
  hsk_test_ready: 'Preparation',
  hsk_test_ready_tips:
    'This test contains listening exercises.  Please adjust your audio settings as necessary.',
  hsk_test_content: 'Content',
  hsk_test_num: 'No. Questions',
  hsk_total_num: 'Total Questions',
  hsk_test_time: 'Time',
  hsk_time_total: 'Total time',
  hsk_test_minute: 'mins.',
  hsk_about: 'About',
  hsk_abbreviation: 'Abbreviate',
  hsk_determine_ans: 'Sure you want to start?',
  hsk_determine_ans_tips: 'Once you start your answer, you cannot view the original text again',
  no_data: 'No data',
  hsk_question_number: 'No. questions',
  hsk_test_rate: '% of Exam',
  hsk_right_rate: 'Correct',
  hsk_operation: 'Actions',
  hsk_skip: 'Skip',
  hsk_spend: 'Spend',
  hsk_cost: 'Cost',
  hsk_credit: 'Credit',
  hsk_pay_successfully: 'Payment succeeded',
  hsk_select_amount: 'Select top up amount',
  button_common_ok: 'Yes',
  button_common_cancel: 'No',
  change_lang_ok: 'Confirm',
  change_lang_cancel: 'Cancel',
  hint_player_loader_error: 'Failed to play audio',
  hint_common_wait_loading: 'Downloading resources …',
  button_common_hand_in: 'Submit',
  test_total_question: '{count} questions in total',
  test_release: 'Publish',
  test_off_shelf: 'Unpublish',
  test_enable: 'Publish',
  test_record: 'Record of completed mock papers',
  test_finish_time: 'Completed',
  test_paper: 'Mock paper',
  test_confirm_use: 'Publish mock paper',
  test_confirm_off_shelf: 'Unpublish mock paper',
  test_has_on_shelf: 'Available',
  test_un_release: 'Unpublished',
  test_un_enable: 'Unavailable',
  test_max_score: 'Highest score',
  test_average_score: 'Average score',
  test_min_score: 'Lowest score',
  test_all: 'All',
  test_has_practiced: 'Review',
  test_paper_office: 'Paper no longer available',
  test_complete_introduce: 'Full description',
  test_course_link: 'Official courses',
  test_about_down_load: 'Downloads',
  test_pay: 'Pay',
  mark_answer_user: 'Submitter',
  mark_answer_time: 'Submission time',
  mark_correct_time: 'Assessment time',
  mark_correct_status: 'Status',
  mark_correct_user: 'Assessor',
  mark_correct_option: 'Actions',
  mark_correct_ing: 'Assessing',
  mark_un_correct: 'Unassessed',
  mark_has_correct: 'Assessed',
  mark_report_tips:
    'Note: the Writing Part has not yet been included in the total score.  Questions 99-100 will be marked by a professional examiner within 48 hours.  Your score will be immediately updated here and we will notify you by email.',
  mark_report_tips_hskk:
    'Note: The test questions will be graded by professional evaluators within 48 hours. After the grading is completed, the general branch will update them synchronously. We will notify you by email at that time',
  mark_submit_btn: 'Submit',
  mark_submit_tips: 'Submit your answers?',
  mark_back: 'Back',
    hsk_answer_sheet: 'Answer Sheet',
  mark_correct_tips: 'The current mock paper is being assessed and cannot be modified.',
  mark_correct_person: 'Manual assessment',
  search_user_message: 'Search for user',
  mark_current_user: 'Current user',
  mark_correct_paper: 'Assess',
  mark_all_status: 'All statuses',
  mark_all_level: 'All levels',
  mark_all_tenant: 'All tenants',
  mark_tenant_name: 'Tenant',
  mark_overtime: 'Overdue',
  mark_answer: 'Answer',
  mark_ai_suggest_score: 'AI suggested score',
  home_test_registration: 'Register',
  home_word_outline: 'Syllabus',
  home_online_practice: 'Sample',
  home_test: 'Papers',
  home_page: 'Home',
  common_text_control_speed: 'Speed',
  button_common_playback: 'Play recording',
  common_text_file_error: 'Failed to download resources.  Please try again.',
  common_text_server_error: 'Try again',
  common_text_none_network: 'Network unstable',
  button_common_start_over: 'Retry',
  evaluating_tips_common:
    'There is a big difference between your recording and the text.  Please try again.',
  evaluate_common_total_score: 'Score',
  evaluate_common_training_remain: 'Remaining:',
  evaluate_common_training_readyRcord: 'Prepare for recording',
  evaluate_common_training_atleast: 'The recording needs to be more than 1 sec.',
  evaluate_common_training_atleast2: 'The recording needs to be more than 2 secs.',
  evaluate_common_training_evaluting: 'Grading',
  evaluating_tips_additionalAndBack: 'Repeat reading',
  textbook_chioce_word_text_correct_tip: 'Correct answer. Great!',
  textbook_chioce_word_text_error_tip: 'Incorrect answer. Keep at it!',
  textbook_reading_comprehension_stem: 'Reading',
  spc_back_tips: 'Quit?  Your answers will not be saved.',
  spc_level_text: 'Level testing',
  spc_capability_assessment: 'Capability Assessment',
  spc_pick_level: 'Pick level',
  spc_listen: 'Listening',
  spc_speak: 'Speaking',
  spc_read: 'Reading',
  spc_write: 'Writing',
  spc_translation: 'Translation',
  spc_result_tips: 'From your level test, it looks like you are working towards HSK {level}.',
  spc_recommend_test: '推荐备考 HSK {level} 级',
  spc_recommend_test1: 'You are working towards <strong> HSK {level}</strong>',
  spc_again_test: 'Test again',
  spc_where_tips: 'Not sure which level you are at?',
  spc_immediate_test: 'Take a test',
  spc_test_content: 'Contents',
  spc_test_content_desc:
    'This adaptive test presents a range of questions designed to assess your abilities across different levels. It evaluates your Listening, Reading, Speaking (reading aloud), Writing (typing or selecting characters), and Translation skills.',
  spc_test_timer: 'Time',
  spc_test_timer_desc:
    'The test takes about 15 minutes—usually shorter for beginners and a bit longer for more advanced levels.​',
  spc_test_result: 'Results',
  spc_test_result_desc:
    'Quickly find out your HSK level and see which areas you need to focus on to improve.',
  vocab_level_word: '{level} Vocabulary List',
  vocab_total_item: '{total} items in total',
  vocab_search: 'Search',
  vocab_all_marked: 'All',
  vocab_already_marked: 'Bookmarked',
  vocab_unmarked: 'Not bookmarked',
  vocabulary: 'Characters',
  vocab_pinyin: 'Pinyin',
  vocab_translate: 'Meaning',
  vocab_mark: 'Bookmark',
  delete_confirmation: 'Delete vocabulary item?',
  cancel: 'Cancel',
  del: 'Delete',
  edit_vocab: 'Edit vocabulary',
  save: 'Save',
  add_vocab: 'Add vocabulary',
  hanzi: 'Chinese',
  num_bihua: 'Strokes',
  write_demo: 'Animation',
  vocab_side: 'Components',
  level: 'Levels',
  see_more: 'View more',
  same_read_word: 'Sounds the same',
  samilar_read_word: 'Sounds similar',
  add_mark: 'Bookmark',
  word_team: 'Words',
  instance: 'Example Sentences',
  include_num_char: 'Comprises {total} characters',
  length_diff: 'The numbers of Pinyin syllables and Chinese characters do not match',
  add_word_success: 'Vocabulary successfully added',
  add_word_fail: 'Failed to add vocabulary',
  edit_word_success: 'Vocabulary successfully edited',
  edit_word_fail: 'Failed to edit vocabulary',
  del_success: 'Deleted',
  del_fail: 'Failed to delete',
  mark_free: 'Freely marked, e.g. marked as "mastered"',
  write_word_sentence: 'Please make a sentence based on the words above…',
  write_word_artical: 'Please write a short essay based on the keywords above …',
  write_img_artical: 'Please write a short essay based on the picture above …',
  write_artical_title: 'Please enter your title …',
  write_artical_content: 'Please type your content …',
  my_wallet: 'My purchases',
  learn_history: 'My history',
  manage: 'Lookup users',
  birthday: 'Date of birth',
  email: 'Email',
  change_pw: 'Change password',
  edit_info: 'Edit details',
  lastName: 'Family name',
  firstName: 'Given name',
  gender: 'Gender',
  female: 'Female',
  male: 'Male',
  non_disclosure: 'Other/anon',
  change_avatar: 'Change avatar',
  preview_avatar: 'Preview',
  upload_image: 'Upload image',
  change_image: 'Change image',
  enter_old_pw: 'Old password',
  enter_new_pw: 'New password',
  enter_new_pw_again: 'Type your new password again',
  forget_pw: 'Forgot password',
  recharge: 'Top up',
  left_balance: 'Available credit',
  consume_log: 'Papers',
  recharge_log: 'Purchases',
  consume_time: 'Date/time',
  consume_source: 'Credits spent on',
  consume_money: 'Credits',
  total_item_log: '{total} records in total',
  recharge_time: 'Date/time',
  recharge_num: 'Credits',
  recharge_money: 'Amount',
  recharge_method: 'Method',
  learn_content: 'Mock paper',
  total_score: 'Total',
  view_result: 'View results',
  management: 'Lookup users',
  give_history: 'Gifted history',
  total_recharge: 'Total spent',
  last_login: 'Last log in',
  give: 'Give papers',
  gifted: 'Gifted',
  give_time: 'Date/time',
  give_to_person: 'Given to',
  opera_person: 'Given by',
  give_to: 'Give papers to',
  old_password_empty: 'Old password field can not be left empty',
  diff_password: 'The entered passwords do not match',
  change_pw_success: 'Password has been updated',
  change_pw_fail: 'Failed to change password',
  change_info_success: 'Information successfully updated',
  change_info_fail: 'Failed to update information',
  statistics_center: 'View statistics',
  select_recharge_mount: 'Select top up amount',
  waiting_pay: 'Pending payment ...',
  has_no_resolve_credit: 'Payment has not been received.  Please try purchasing again.',
  complete_pay: 'Payment completed',
  pay_fail: 'Payment failed',
  give_success: 'Credits successfully given',
  give_fail: 'Failed to give credits',
  change_avatar_success: 'Avatar successfully updated',
  change_avatar_fail: 'Failed to update avatar',
  enter_family_name: 'Family name',
  enter_given_name: 'Given name',
  log_in: 'Log in',
  log_in_error: 'Login failed',
  email_address: 'Email',
  invalid_email_address: 'Not a valid email format',
  password: 'Password',
  password_tip: 'Password must be 6-20 characters long',
  invalid_password: 'Password format incorrect',
  have_account: 'Already have a {text} account',
  sign_up: 'Sign up',
  sign_up_error: 'Registration failed',
  forget_pw_success: 'Reset password email successfully sent',
  forget_pw_error: 'Failed to send reset password email',
  loading: 'Loading',
  account_block: 'This account is disabled',
  account_block_tip: 'Please contact an Agent at your school or organisation for more information',
  resend_email: 'Resend email',
  resend_email_success: 'Email successfully resent',
  resend_email_error: 'Failed to resend email',
  i_am: '我是',
  choose_role: 'Which one best describes you',
  choose_role_error: 'Wrong role selected',
  continue: 'Continue',
  learner: 'Learner',
  learner_description: 'I am learning Chinese',
  teacher: 'Teacher',
  teacher_description: 'I am teaching Chinese',
  setup_account_error: 'Failed to set up account',
  tos_link: 'Terms of Use',
  privacy_link: 'Privacy Policy',
  email_verified: 'Email verified!',
  email_verified_tip: 'Thank you for verifying your email.',
  email_verified_error: 'Failed to verify your account',
  something_wrong: 'Something went wrong',
  retry: 'Retry',
  guardian_consent_error: 'Consent failed',
  about_us: 'About us',
  about_us_new: 'About us',
  feedback: 'Contact Us',
  download: 'Download',
  submit: 'Send',
  feedback_success: 'Successfully sent',
  feedback_error: 'Failed to send',
  feedback_contact_tip: 'After submission, we will contact you promptly via the email address you used to register.',
  logout: 'Log out',
  my_account: 'My account',
  login_signup: 'Log in / Sign up',
  please_enter_content: 'Your message (required)',
  describe_detail: "If you're describing an error, please provide as much detail as you can",
  upload_picture: 'Upload up to {maxFiles}x jpg/png images (optional), max. 2MB for each image.',
  file_error: 'File is in wrong format or is too large',
  file_num_limit: 'Maximum number of uploads: {maxFiles} files',
  sure_change_lang: 'Change language?',
  privacy_policy_text1: 'HSK Mock.com——汉考国际唯一认证的模拟考试平台',
  privacy_policy_text2:
    '模拟考试平台由Wo Hui和汉考国际基于HSK和YCT试题库合作开发和运营。提供完整真题模考训练，为中文学习者的标准化中文考试保驾护航。',
  privacy_policy_text3: 'Wo Hui Mandarin是汉考国际官方合作伙伴。',
  privacy_policy_text4:
    '汉考国际教育科技（北京）有限公司，是专业化国际中文教育考试服务机构，致力于为世界各国（地区）提供国际中文教育和考试研究设计、技术研发、考试实施、市场推广等方面的专业化服务，最大限度满足全球中文学习者和中文教育机构的需求。',
  privacy_policy_text5:
    '我会是由EiM国际教育集团于2018年在新加坡创立的，致力于为全球的中文学习者提供学习中文的技术支持、平台服务的独立公司。为不同的学生提供多样的课程；为教师提供海量教学资源与实用教学工具。科技智能辅助教学，解放教师双手，完善教学过程，帮助学生实现自己的个性化目标，鼓励学生成为卓越的独立学习者。',
  privacy_policy_text6:
    '汉考国际与我会具有良好的合作基础，共同致力于中文学习的推广与发展。为更精准的判断学生的水平，进行针对性学习，模拟真实考试环境，两者进行深度的战略合作，全方位满足中文学习者的学习需求。',
  level_test: 'Level testing',
  level_test_example:
    'If you are not sure which level you are at, take a short test free of charge to find out which exam level to work towards next.',
  download_app_mobile:
    'To use HSK Mock, please visit hskmock.com on a desktop or download the mobile app',
  common_video_failed: 'Failed to load audio',
  member_error: 'Something went wrong with the resource！',
  agree_policy:
    'I agree to <u class="strong"><a href="{url}" target="_blank">Terms of Services</a></u> and <u class="strong"><a href="{url}" target="_blank">Privacy Policy</a></u>',
  please_check: 'Please read and agree to Terms of Services and Privacy Policy',
  media_devices_unsupported_browserLabel:
    'Google Chrome is recommended as the default browser. Setting method (taking Windows 10 as an example): Settings-Application-Default application-Web browser-select Google Chrome',
  media_devices_help_title: 'Turn on the microphone or not',
  media_devices_help_content: 'You need permission to access the microphone to record audio',
  batch_exist_user: '{number} registered',
  batch_and: 'and',
  batch_un_exist_user: '{number} unregistered',
  batch_from: 'From',
  batch_notes: 'Notes',
  batch_something: 'Write something',
  batch_people_number: 'Given to',
  batch_use_number2: 'Spent',
  batch_operation_status: 'Status',
  batch_ing_status: 'In progress',
  batch_success: 'Succeeded',
  batch_failed: 'Failed',
  batch_select: 'Select',
  common_to: 'to',
  common_start_time: 'Start',
  common_end_time: 'End',
  batch_search_tips: 'Separate multiple email addresses with a comma, up to 50 emails at a time.',
  common_un_exist: 'Unregistered',
  common_invalid: 'Invalid',
  batch_all_give: 'Give papers to all',
  batch_single_people: 'Individuals',
  batch_all: 'Batches',
  batch_name: 'Name',
  batch_added_credits: 'Added credits',
  batch_spent_credits: 'Spent credits',
  batch_account_status: 'Account status',
  batch_Added_total: 'Added total',
  batch_spent_total: 'Spent total',
  batch_Remaining: 'Remaining',
  batch_Recipients: 'Recipients',
  batch_Active: 'Active',
  batch_search: 'Search',
  certificate_details: 'Certificate details',
  get_official_mock_certificate: 'Certificate',
  certificate_tips: 'Edit the details for your certificate if necessary.',
  country: 'Nationality',
  select_country: 'Please select your nationality',
  email_to: 'The certificate will be emailed to:',
  polyphonic: 'Multiple sound word',
  click_tips: 'Click a question number to view your answer',
  download_tips: 'You can download a certificate for any mock test that you pass',
  cancel_delete_account: 'Delete account',
  cancel_confirm: 'Confirm',
  user_apply_delete_account_title: 'Request for account to be deleted',
  user_apply_delete_account_confirm_tip: 'Confirm your log in details',
  user_apply_delete_account_alwaysTip:
    'You are requesting your Mock HSK account and associated personal data to be permanently deleted now.',
  user_apply_delete_account_confirm_tip2: 'To submit this request, please confirm your identity.',
  user_apply_delete_account_desc:
    'Your account {email} is used to log in to the <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> and <a href="{mockLink}" target="_blank">HSK Mock</a> apps',
  user_apply_delete_account_desc2:
    'After deletion, you will no longer be able to use this account to log in to the above applications.',
  user_apply_delete_account_wohui_title: 'Cancel Wo Hui subscription',
  user_apply_delete_account_hsk_title: 'HSK MOCK CREDITS',
  user_apply_delete_account_next_tip:
    "By clicking the 'Next' button, you confirm that you have read and agreed to the above.",
  user_apply_delete_account_next_title: 'Next',
  user_apply_delete_account_confirm_tip11:
    'Please first cancel your subscription, then come back to complete your request for your account to be deleted.',
  cancel_delete_ok: 'OK',
  cancel_delete_request_send: 'Request send',
  user_apply_delete_account_confirm_tip8:
    'Your account will be permanently deleted when your subscription expires on {date}',
  user_apply_delete_account_confirm_tip4: 'We will send an email to',
  user_apply_delete_account_confirm_tip5: 'to confirm that your account has been deleted.',
  user_apply_delete_account_confirm_tip6:
    'To cancel your request to delete this account click “Cancel”',
  user_apply_delete_data_always:
    'Would you like to cancel your request to permanently delete your Wo Hui Mandarin account and associated personal data?',
  cancel_delete_yes: 'Yes',
  cancel_delete_no: 'No',
  user_cancel_delete_success:
    'We have cancelled your request and will not delete your HSK Mock account.',
  user_cancel_subscribe_again:
    'You will need to re-subscribe to any subscription you previously cancelled.',
  user_apply_delete_account_confirm_tip9: 'Your subscription expires on',
  user_apply_delete_account_confirm_tip10: 'When would you like to delete your account?',
  user_apply_delete_account_ok_btn_title: 'When your subscription expires',
  user_apply_delete_account_now_btn_title: 'Now',
  cancel_out_subscription_abnormal: 'Subscription information is abnormal',
  user_apply_delete_account_confirm_tip3:
    'You have a subscription which is automatically billed to you by Apple. Please cancel your subscription with Apple before continuing.',
  user_apply_delete_stripe_tip:
    'You have a subscription which is automatically billed to your credit/debit card by Stripe. Please go to our website',
  user_apply_delete_account_balance: 'Account Balance',
  user_apply_delete_account_balance_tip:
    'Once your account has been deleted, these credits will be lost forever.',
  user_apply_delete_account_expire: 'Your account will be permanently deleted within three days',
  my_class_name: 'My classes',
  my_class_search: 'Search class',
  my_class_total: 'Total',
  my_class_people: 'People',
  my_class_ci: 'Times',
  my_class_number: 'Number of people',
  my_class_ci_number: 'Number of times',
  my_class_tips: 'Inner circle: distribution of YCT and HSK exams.',
  my_class_tips1: 'Outer circle: distribution of levels.',
  my_class_all_class: 'All classes',
  follow_lesson: 'Follow a course',
  real_paper: 'Do a real paper',
  start_answer: 'Start',
  edit_message_date: 'Date',
  edit_message_language: 'Language',
  edit_message_zh: 'Chinese',
  edit_message_en: 'English',
  edit_message_title: 'Title',
  edit_message_content: 'Please enter text',
  edit_message_show: 'Show on',
  edit_message_save_success: 'Saved successfully',
  edit_message_create_success: 'Successfully added',
  edit_message_edit1: 'Edit',
  edit_message_follow_notice: 'Manage notifications',
  edit_message_textarea_tips: 'Include a space after any links',
  edit_message_notifications: 'Manage notifications',
  edit_message_Send_time: 'Send',
  edit_message_edit_notification: 'Edit notification',
  edit_message_add: '+ Add',
  edit_message_from: 'From',
  edit_message_to: 'To',
  edit_message_new_add: 'Add notification',
  currency: 'Currency',
  pay_failed: 'Checkout page not loaded?',
  pay_un_finished: 'Cannot complete payment?',
  select_currency_tips: 'If you wish, you can select a different currency from the drop-down below',
  change_currency_tips: 'You can change your preferred currency at any time under “My account.”',
  my_homework: 'My assignments',
  my_homework_add: 'Send assignment',
  my_homework_all_classes: 'All Classes',
  my_homework_paper: 'Paper',
  my_homework_sent_to: 'Sent to',
  my_homework_sent_on: 'Start after',
  my_homework_due_on: 'Due before',
  my_homework_submitted_assignees: 'Submitted/Assignees',
  my_homework_class_hint: 'means the paper was only assigned to some of the learners in the class.',
  my_homework_delay_hint: 'means the paper can still be submitted after the due date.',
  my_homework_add_send_assignment: 'Update Assignment',
  my_homework_add_new_assignment: 'New assignment',
  my_homework_edit_assignment: 'Edit assignment',
  my_homework_add_assignment: 'Add assignment',
  my_homework_add_assignment_details: '1. ASSIGNMENT DETAILS',
  my_homework_add_issue_time: 'Send',
  my_homework_add_whether_submit: 'Allow submission after due date and time?',
  my_homework_add_note: 'Note',
  my_homework_add_assignees: '2. ASSIGNEES',
  my_homework_edit_add_assignees: 'ASSIGNEES',
  my_homework_add_group: 'Select class',
  my_homework_add_immediate_release: 'Now',
  my_homework_add_time_release: 'Later',
  my_homework_add_are: 'Yes',
  my_homework_add_no: 'No',
  my_homework_detail_back: 'Back to My assignments',
  my_homework_detail_sent_to: 'Sent to',
  my_homework_detail_leamers_in: 'leamers in',
  my_homework_detail_on: 'on',
  my_homework_detail_to_complete_by: 'to complete by',
  my_homework_detail_add_assignee: 'Add assignee',
  my_homework_detail_assignee: 'Assignees',
  my_homework_search_placeholder: 'Please enter search content',
  my_homework_stu_sent_by: 'Sent by',
  my_homework_total_topic_count: '{count} questions in total',
  my_homework_time_full: '{min} min',
  my_homework_preview: 'Preview',
  cookie_consent_title: 'Cookie Consent',
  cookie_consent_desc1: 'We use cookies to analyze website usage to improve your experience.',
  cookie_consent_desc2: 'By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to enhance site navigation and analyze site usage. You may click “Reject All” to decline non-essential cookies.',
  cookie_consent_policy_link: 'Read our Cookies Policy.',
  cookie_consent_reject: 'Reject All',
  cookie_consent_accept: 'Accept All Cookies',
  my_homework_select_date_time: 'Select date and time',
  my_homework_delete_assignment_title: 'Delete Assignment',
  my_homework_delete_assignment_tips:
    'Are you sure you want to delete this assignment? This action cannot be undone!',
  my_homework_assignment_add_fail: 'publishing failed!',
  my_homework_assignment_add_success: 'Assignment sent!',
  my_homework_assignment_edit_success: 'successfully edited!',
  my_homework_assignment_edit_fail: 'editing failed!',
  my_homework_assignment_delete_fail: 'delete failed!',
  my_homework_assignment_delete_success: 'successfully deleted!',
  my_homework_assignment_due_on: 'Due on',
  my_homework_assignment_product: 'Product',
  my_homework_assignment_certificate: 'Certificate',
  my_homework_assignment_reset: 'Reset',
  reset_paper: 'Reset Test',
  my_homework_assignment_reset_title: 'Reset section?',
  my_homework_assignment_gifted: 'Total gifted',
  my_homework_assignment_papers: 'papers',
  my_homework_assignment_send_to: 'This assignment was sent to',
  my_homework_assignment_close_tip:
    'The current assignment has not been saved yet. Are you sure to exit?',
  pay_callback_tips:
    'If you are in mainland China and wish to use Alipay or Wechat to pay for mock tests, please use our China service at hskmock.cn',
  no_available_class: 'No classes',
  payment_method: 'Payment method',
  wechat_pay: 'WeChat Pay',
  alipay_payment: 'Alipay payment',
  card_payment: 'Pay by card',
  card_payment_description: 'Overseas bank cards only',
  payment_to_wohui: 'Payment to Wohui Technology (Shanghai) Co., Ltd.',
  order_submitted: 'Order submitted successfully, please make payment as soon as possible!',
  order_number: 'Order number:',
  code_expires:
    'The code will expire in  <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>.',
  use_weChat: 'Please use WeChat to scan the QR code and complete the payment',
  code_expired: 'The QR code is no longer valid',
  amount_payable: 'Amount payable：',
  use_code: 'Use Code',
  tests: 'Tests',
  level_title: 'Which level are you working towards?',
  level_des:
    '<b>Not sure where to begin?</b><br />Take a <b style="color: #000;cursor: pointer;font-weight: 400;" class="clickable">free level test→</b>',
  level_HSK_text1: '<b>HSK</b>  stands for “Hanyu Shuiping Kaoshi,” meaning Chinese Level Tests.',
  level_HSK_text2: 'They are the world’s most popular Chinese language proficiency tests.',
  level_YCT_text1: '<b>YCT</b>  stands for “Youth Chinese Tests.”',
  level_YCT_text2:
    'They are a version of the Chinese language proficiency tests adapted for younger learners.',
  level_PRIMARY: 'Primary',
  level_BEGINNER: 'Beginner',
  level_INTERMEDIATE: 'Intermediate',
  level_ADVANCED: 'Advanced',
  level_dialog_title: 'Level test',
  level_dialog_content:
    'This free adaptive level test takes about 15 minutes. It will evaluate your skills in Listening, Reading, Writing, and Speaking, and help you identify your current HSK level, as well as the areas where you can improve.',

  level_dialog_login: 'Log in / Sign up',
  level_dialog_start: 'Start level test',
  about_us_first_paragraph:
    '<b>HSK Mock</b> is the only official platform for practice tests for HSK and YCT, the world’s most popular Chinese language proficiency tests.  The platform is the product of a collaboration between <b>Chinese Testing International</b> and <b>Wo Hui Mandarin</b>.',
  about_us_second_paragraph:
    '<b>Chinese Testing International</b> (CTI) is the examination board for HSK and YCT.  They are a limited company headquartered in Beijing which promotes and supports the learning, teaching and testing of Chinese as a foreign language around the world by providing a range of services to both individuals and institutions.',
  about_us_third_paragraph:
    '<b>Wo Hui Mandarin</b> (Wo Hui) provides the official online platforms for HSK and YCT courses and practice tests.  They are a limited company headquartered in Singapore which leverages technology to put learning in the hands of the student and empower their teachers to support them on their personal learning journey.',
  about_us_cti_text: 'Discover more at:',
  about_us_wohui_text: 'Do get it touch if you’d like to explore more:',
  listening_section: 'Listening section',
  reading_section: 'Reading section',
  writing_section: 'Writing section',
  review_answers: 'Review answers',
  characters_long:
    'If you don’t yet have an account, set a password between 6 and 20 characters long.',
  complete_profile: 'Complete your profile',
  verify_email: 'Verify your email',
  link_sent:
    'Thank you for signing up. Please verify we have the correct email address <br /> for you by clicking on the link we have sent to:',
  resend_link: 'Resend link >',
  restart: 'Restart',
  parental_consent: 'Parental consent',
  sent_parental:
    'Thank you for signing up. Please ask your parent or guardian to give <br /> their consent by following the instructions we have sent in an email to:',
  thank_you: 'Thank you!',
  or_return: 'Or return to the mobile app',
  child_profile: "Your child's profile",
  sign_up_privacy:
    'I have read and agree to the <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">Terms of Service</a> and <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">Privacy Policy</a>',
  give_consent: 'I give my consent',
  delete_child_details: 'Delete my child’s details',
  account_created: 'Account created',
  emailed_know: "We have emailed <span style='font-weight: 700'>{email}</span> to let them know.",
  account_deleted: 'Account deleted',
  child_know_deleted: 'Please let your child know their details have been deleted.',
  request_email:
    'All these details (except the email address) can be updated after log in. Please give your consent to your child creating an account with us or else request that we delete their details.',
  preferred_currency: 'Preferred currency',
  parent_guardian: 'Parent/Guardian',
  class_name: 'Class name',
  tofficial_platform: 'Your Official HSK<br />Preparation Platform',
  tofficial_platform_new: 'Your Official HSK<br />Preparation Platform',
  proficiency_tests:
    'Get HSK-ready with authentic exam content, reliable scoring, vocabulary improvement, and free smart practice tools.',
  proficiency_tests_new:
    'Get HSK-ready with authentic exam content, reliable scoring, vocabulary improvement, and free smart practice tools.',
  get_started: 'Get started',
  get_started_new: 'Get started',
  start_practicing: 'Start Practicing',
  get_ready: 'Get Ready for the HSK',
  real_hsk_exam_content: 'Real HSK Exam Content',
  real_hsk_exam_content_new: 'Check Your HSK Level',
  real_hsk_exam_desc: 'Practice with real HSK exams to prepare effectively and confidently.',
  real_hsk_exam_desc_new: 'Take a short placement test and get your recommended HSK level.',
  official_level_scoring: 'Official-level Scoring',
  official_level_scoring_new: 'Take an Official HSK Mock Test',
  official_level_scoring_desc:
    'Receive scoring based on official HSK standards for reliable results.',
  vocabulary_boost: 'Vocabulary Boost',
  vocabulary_boost_new: 'Improve Your Vocabulary',
  vocabulary_boost_desc:
    'Improve your word retention with free flashcards, quizzes, and smart review tools.',
  vocabulary_boost_desc_new:
    'Free flashcards, quizzes, and smart review tools.',
  get_hsk_ready: 'Get HSK-Ready',
  how_it_works: 'How It Works',
  choose_your_level: 'Choose Your Level',
  choose_your_level_desc: 'Pick the HSK level that suits your goal – from HSK 1 to HSK 9.',
  practise_and_learn: 'Practice & Test',
  practise_and_learn_desc:
    'Use free vocabulary tools, or upgrade to unlock full HSK mock exams with instant scoring.',
  track_your_progress: 'Track Your Progress',
  track_your_progress_desc:
    'See your scores by section after each test, and follow your improvement over time to know when you’re ready for the real HSK.',

  got_questions: 'Got Questions? We’ve Got answers',
  faq: 'FAQ',
  faq_desc: 'Find answers to the most common questions about HSK preparation and our platform.',
  faq_btn: 'Browse FAQs',

  blog: 'Blog',
  blog_desc: 'Explore our blog for tips, strategies, and expert advice on your HSK exams.',
  blog_btn: 'Read the Blog',

  contact: 'Contact',
  contact_desc:
    'Need personalised help? Get in touch with our support team for any questions or concerns.',
  contact_btn: 'Get in Touch',

  mock_tests: 'Mock tests',
  blog_and_faq: 'Blog & FAQ',
  real_results_from_real_learners: 'Real Results from Real Learners',
  support: 'Support',
  choose_your_hsk_level: 'Choose Your HSK Level',
  choose_your_hsk_level_desc: 'Prepare for HSK, HSK Speaking, and YCT with official mock exams and smart tools.',

  hsk_levels: 'HSK',
  hsk_speaking: 'HSK Speaking',
  yct: 'YCT',
  // hsk3.0
  hsk_levels_tri: 'New HSK',
  hsk_speaking_tri: 'New HSK Speaking',

  for_hsk3_condidates: 'For HSK 3<br />Candidates',
  for_hsk4_condidates: 'For HSK 4<br />Candidates',
  for_hsk56_condidates: 'For HSK 5-6<br />Candidates',

  platform_china: 'We also offer this platform for candidates inside mainland China.',
  take_confidence: 'Take your HSK with confidence',
  practice_tests: 'Practice HSK and YCT tests',
  using_time:
    'using actual recent past HSK papers from the HSK examination board, so that you are used to the format of the HSK test, to answering the different types of HSK question, and to completing each section within the prescribed time.',
  instant_results: 'Get instant results',
  each_test_question:
    'and review each test question by question.  Your tests are not only graded for you, but you can see exactly which questions you got right.  For those you got wrong, you can also see the correct answer so that you know what specifically you still need to work on.',
  track_progress: 'Track your progress step-by-step',
  ready_next_test:
    'so that you know exactly when you are ready to take the next real HSK test and can go in to it assured of getting the best possible result. Your history shows you the date and time that you took each HSK practice test and how your results for each skill have changed from one HSK test to the next.',
  receive_official_certificates: 'Receive official HSK Mock certificates',
  certificates_provide_evidence:
    'for every practice HSK test you pass. These certificates provide evidence that you have achieved a certain HSK level of Chinese language proficiency.',
  ready_next_level: 'Be ready for the next HSK level',
  check_description:
    'Check out the description of your next HSK level so you know what you are aiming for. Familiarise yourself with the format of the HSK test so you know what to expect. Preview and review the prescribed HSK vocabulary so you know you’ve covered everything you might be tested on.',
  on_the_move: 'Take your HSK Practice Anywhere.',
  on_the_move_new: 'Take your HSK Practice Anywhere.',
  download_mobile: 'Download the HSK Mock APP',
  download_mobile_new: 'Download the HSK Mock APP',
  footer: 'HSK Mock is the official platform for HSK Exam preparation.</br>Practice with Real Tests, Track Your Progress, and Build Confidence to Ace the HSK.',
  isp: 'Copyright © 2025 HSK Mock',
  start_learning: 'Start Learning Today!',
  for_institutions: 'For schools & institutions',

  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span> stands for “Hanyu Shuiping Kaoshi,” meaning Chinese Level Tests. They are the world’s most popular Chinese language proficiency tests. There are 9 levels, from beginner to advanced.',
  more: 'More >',
  more_menu: 'More',
  ytc_beginner_advanced:
    "<span style='font-weight: 700'>YCT</span> stands for “Youth Chinese Tests.” They are a version of the Chinese language proficiency tests adapted for younger learners. There are 4 levels, from beginner to intermediate.",
  coming_end: 'Coming at the end of 2023',
  candidates_proficiency_speaking: "They test candidates' proficiency in speaking.",
  level_oral_tests:
    "<span style='font-weight: 700'>HSKK</span> stands for “Hanyu Shuiping Kouyu Kaoshi,” meaning Chinese Level Oral Tests.",
  check_test_dates: 'Check HSK test dates',
  book_test: 'Book an HSK test',
  international_platform:
    'Our China platform is hosted within mainland China; our international platform is hosted in Singapore. The two platforms are entirely separate.  Please choose the platform that is most suitable for you.',
  mock_platform: 'The official mock testing platform',
  home_proficiency_tests: 'for the world’s most popular Chinese language proficiency tests.',
  currency_type: 'Currency',
  Pick_your_level: 'Pick your level',
  About_this_level: 'About this level',
  test_session: 'test session',
  Learning_resources: 'Learning resources',
  Take_practice_test: 'Practice test',
  Compare_syllabuses: 'Compare syllabuses',
  table_shows_syllabuses: 'This table shows the approximate HSK level of different syllabuses.',
  forrgin_lang: '0547 is for "Chinese as a Foreign Language"',
  Second_Language: '0523 is for "Chinese as a Second Language"',
  Requirement_entry: 'Requirement for entry into',
  most_Chinese_universities: 'most Chinese universities',
  Qing_Hua: 'Qing Hua University',
  beijing_university: 'Beijing University',
  working_towards: 'you were working towards',
  On: 'On',
  Level_test: 'Level test',
  Retake_level_test: 'Retake level test',
  practice_test: 'Take a practice test',
  Compare_syllabuses_a: 'Compare with other syllabuses',
  Not_sure: 'Not sure of your level?',
  free_level_test: 'Take a free level test',
  Examples: 'Examples',
  product_code: 'Product code',
  enter_paper: 'Enter your code to take a practice test with this paper.',
  no_code: "Don't have a code? Purchase one from our partner:",
  to_partner: 'Go to partner',
  code_here: 'Enter code here',
  start_assigment: 'Start',
  view_assigment: 'View',
  continue_assigment: 'Continue',
  choose_method: 'Choose a purchase method',
  choose_new_method: 'Please choose a method to start the new test.',
  browser_layer: 'Please use Google Chrome browser on your PC or APP on your mobile device.',
  partner_title1: 'Could you be our',
  partner_title2: 'Local Partner?',
  company_name: 'Company name',
  company_website: 'Company website',
  teachers_count: 'Number of HSK teachers you work with',
  learners_count: 'Number of HSK learners you work with',
  add_msg: 'Feel free to add a message to us if you would like to',
  contact_style: 'How best to contact you?',
  send: 'Send',
  partner_forms_desc:
    'As our local partner, you would be the primary point of contact with candidates, teachers, schools and universities in your country or region for our services.<br><br>Our partner dashboard and api would enable you to sell our official HSK and YCT practice tests offline and/or on your own website in your local currency. Our partners are typically well-established and connected HSK testing and preparation centers looking to grow their business and increase their official recognition. <br><br>If you would like to explore the possibility of becoming our local partner, please first <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">log in</span> with a personal HSK Mock account.  Then let us know some basic details below and we will be in contact to arrange a time to talk.',
  submit_success: 'Submitted successfully',
  help_students_for_testing: 'Helping students to prepare for their HSK tests?',
  help_students_for_testing_desc:
    'Teachers have a vital role to play in helping learners reach their next HSK exam goal. <br>We liberate and empower teachers to support each of their students on their personal HSK learning journey.',
  become_partner: 'Become our local partner',
  become_partner_desc:
    'There is nothing like a local point of contact for candidates where they can talk to someone about tests in their own language and make payments via their preferred local payment methods.',
  partnership: 'Explore partnership',
  students_forward: 'Put your students forward for',
  hsk_confidence: 'HSK with confidence',
  try_it_out: 'Try it out',
  walk_through: 'Walk them through',
  teachers_page_desc1:
    'the features and functions available, either one-to-one or as a whole class.  Familiarise them with the description of each level and the format of each test. Preview and review the prescribed vocabulary together.',
  assign_practice_papers: 'Assign practice papers',
  teachers_page_desc2:
    'to your students to complete by a date and time of your choosing.  Use the papers as formal assessments or to get your students used to answering the different types of question in the HSK tests and to completing each section within the prescribed time.',
  get_instant_results: 'Get instant results',
  teachers_page_desc3:
    'with no marking!  See which students have already completed your assignments and which have not.  View the scores your students have achieved in every paper they have completed.',
  review_their_answers: 'Review their answers',
  teachers_page_desc4:
    "Drill down into your students' test results class by class, skill by skill, part by part and even question by question. Review the actual answers your students gave so you can identify exactly what each person still needs your help with and give them focussed feedback.",
  track_prog: 'Track progress',
  teachers_page_desc5:
    'A complete and detailed history is compiled for each of your students, showing how their results for each skill are changing from one test to the next so that you know when they are ready to take the next real test and can put them forward with confidence.',
  students_next_level: 'Get your students to the next level',
  teachers_page_desc6:
    'Our sister platform has the official HSK and YCT course material and all the tools and resources you need to teach and to support each of your students on their personal learning journey to their next exam goal.',
  teaching_resources: 'Teaching resources',
  for_teachers: 'For Teachers',
  teachers_desc1:
    'Please first <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">log in</span> with a personal HSK Mock account.',
  teachers_desc2:
    'Then let us know some basic details below and we will set up a trial for your school.',
  school_name: 'School name',
  school_web: 'School website',
  num_of_hsk_teachers: 'Number of HSK teachers',
  num_of_hsk_learners: 'Number of HSK learners',
  hsk_submit_reading: 'reading',
  pay_tip:
    'If you wish to use Alipay or Wechat to pay for mock tests, please use our China service at hskmock.cn.',
  use_pc_or_app:
    'To get started, please switch to a laptop/desktop computer or else download our mobile app.',
  download_certificate: 'Download certificate',
  create_certificate: 'Generate certificate',
  certificate_is_downloaded: 'Certificate downloaded',
  pay_discount_title: 'How many {level} test sessions would you like to buy?',
  total: 'Total',
  pay: 'Pay',
  price_desc:
    'The only thing you need to pay for are test sessions. You can get a discounted rate per test as below buy paying for multiple test sessions at once.',
  the_level: 'Level',
  discounted_price: 'Pricing',
  price_contact_us:
    'We also offer options for schools and other organisations who wish to buy for multiple students.  Please <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">contact us</span> to discuss your specific needs.',
  get_a_discount: 'Get a discount',
  finished_pay_discount_title: 'Here are your codes for practice tests at {level_name}:',
  btn_goto_papers: 'Go to the {level_name} papers',
  test_count: '{test_num} test | {test_num} tests',
  unit_price: '{price} / test',
  buy_code_tip:
    'We have also emailed these codes to you.<br /><br />Now simply select the {level_name} paper <br />you want to take a test with and enter a code to unlock it.',
  discount_codes_left_tip:
    'After this test, you will have <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count} codes left</span> for this level',
  manage_class: 'Manage Class',
  to_manage_class:
    'The Class Management system will open in a new tab. When you have finished, please return to this tab and refresh the page.',
  code_used: 'Used',
  code_can_be_used: 'Can be used',
  no_test: 'No.test',
  history_purchase_quantity: 'Quantity',
  hsk_listen_part_title: 'Listening: Part {count}',
  hsk_read_part_title: 'Reading: Part {count}',
  hsk_write_part_title: 'Writing: Part {count}',
  Description: 'Description',
  Test_format: 'Test format',
  Vocabulary: 'Vocabulary',
  other_gender: 'Anon/Other',
  intro_msg_first: 'There are {num} sections in this test, which you must complete in sequence.',
  intro_msg_second: 'You must complete each section within the prescribed time limit.',
  intro_msg_third:
    'You may proceed to the next section before the time limit is reached, but once you move on you will not be able to return to the previous sections.',
  dialogue_listening:
    'The first section is the listening section. Play the audio sample below and adjust the audio settings on your device as necessary.',
  dialogue_listening_hskk:
    'Play the audio sample below and adjust the audio settings on your device as necessary.',
  dialogue_intro_msg_first:
    'There a general introduction, which begins with music. Whilst this introduction is playing, you may preview the questions for the listening section.',
  dialogue_intro_msg_first_hskk:
    'When the music is playing, a general introduction to the exam will follow.',
  dialogue_intro_msg_second:
    'Just like in the real test, you cannot pause, replay or fast forward the audio in the listening section.',
  dialogue_intro_msg_second_hskk:
    'To simulate a real exam, you cannot pause, replay, or fast forward.',
  dialogue_intro_msg_third:
    'At the end of the audio for the listening section, you will have up to {duration} minutes to review your answers.',
  dialogue_intro_question: 'Questions?',
  dialogue_preload_intro_first: 'The audio for the listening section is now downloading.',
  dialogue_preload_intro_second:
    'Once the download is complete, the audio will begin to play automatically to start the test.',
  dialogue_preload_intro_third: 'Good luck!',
  dialogue_preload_title: 'Downloading resources for the test',
  mock_paper_preview: 'Mock test paper preview',
  dialogue_mock_paper_intro_title: 'Instructions',
  dialogue_mock_paper_intro_sentence1:
    'This test takes about {minutes} minutes. Please make sure you have enough time and battery to complete the test in one sitting.',
  dialogue_mock_paper_intro_sentence2:
    'The test is conducted online, so please make sure you have a stable internet connection.',
  dialogue_mock_paper_intro_sentence3:
    'If you are using a desk/laptop computer, please use an up-to-date Chrome or Safari web browser.',
  dialogue_mock_paper_intro_sentence4:
    'If you are using a tablet computer, please use our mobile app rather than the web browser. If the app is force-closed in the background, your test progress cannot be saved.',
  dialogue_mock_paper_intro_sentence5:
    'Please do not open other browser windows or mobile apps, switch languages, or plug in/unplug other devices during the test.',
  dialogue_mock_paper_intro_button: 'I have read and understood',
  deadline_passed: 'Deadline passed',
  sso_login_signup: 'Log in / Sign up',
  sso_email_address: 'Email',
  sso_password: 'Password',
  sso_characters_long:
    'If you don’t yet have an account, set a password between 6 and 20 characters long.',
  sso_forget_pw: 'Forgot password',
  sso_agree_policy:
    'I agree to <u class="strong"><a href="{url}" target="_blank">Terms of Services</a></u> and <u class="strong"><a href="{url}" target="_blank">Privacy Policy</a></u>',
  sso_continue: 'Continue',
  sso_please_check: 'Please read and agree to Terms of Services and Privacy Policy',
  sso_invalid_email_address: 'Not a valid email format',
  sso_invalid_password: 'Password format incorrect',
  sso_loading: 'Loading',
  sso_mock_platform: 'The official mock testing platform',
  sso_home_proficiency_tests: 'for the world’s most popular Chinese language proficiency tests.',
  sso_guardian_consent_error: 'Consent failed',
  sso_forget_pw_success: 'Reset password email successfully sent',
  sso_forget_pw_error: 'Failed to send reset password email',
  sso_log_in_error: 'Login failed',
  sso_download_app_mobile:
    'To use HSK Mock, please visit hskmock.com on a desktop or download the mobile app',
  sso_no_binding_info_tip: 'Failed to obtain your details',
  sso_third_login_tip: 'Please select the website you want to open',
  sso_third_login_wohui: 'Go to Wo Hui Mandarin',
  sso_third_login_mock: 'Go to HSK Mock',
  hsk_enter_listening: 'Listening',
  diologue_mock_paper_quit: 'Quit',
  vocab_type: 'Part of speech',
  mock_skip_introduction: 'Skip introduction?',
  Listening: 'Listening',
  Reading: 'Reading',
  Writing: 'Writing',
  personal_info_display_name_as: 'Display name as',
  code_pratice_text:
    'Take a <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span> mock test using <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span>.',
  code_input_text: 'Type in a code:',
  use_code_limit: 'Each Code can only be used once',
  code_select_text: 'Or select a code:',
  pay_discounts_desc1: 'Practising with past papers will help you',
  pay_discounts_desc2: 'get the best possible results in your [{type}] [{level}] exam.',
  pay_discounts_desc3: 'Buy One Get One Free',
  pay_discounts_desc4:
    'If you are already registered for a real [{type} {level}] exam, you can enjoy a “Buy One Get One Free” offer on [{type} {level}] practice tests!',
  pay_discounts_desc5: 'How many practice tests would you like to buy?',
  level_HSKK_text1:
    'The HSK Speaking Test assesses the test takers’ oral Chinese abilities. It consists of three levels, including primary, intermediate, and advanced.',
  level_HSKK_text2: 'The HSK speaking test is conducted in the form of an audio recording.',
  level_HSKK_text3:
    'HSK3 candidates must take an HSKK Beginner test; HSK4 candidates an Intermediate; and HSK 5 or 6 candidates an Advanced',
  test_download_desc:
    'Practice papers are being prepared for this level.  In the meantime, please download：',
  speaking: 'Speaking',
  Traduction: 'Translating',
  my_homework_none_homework: 'Assignment of tests at this level is not currently supported.',
  my_class_none_test: 'The online mock test experience is not currently available for this level.',
  hsk_audio_error:
    'Your internet connection is unstable and the audio has failed to load. Please try again.',
  mock_join_campus_text1:
    'Do you accept the invitation to join this Chinese language teaching, learning and testing community?',
  mock_join_campus_text2:
    'Joining the community will enable teachers to assign to you test papers on HSKMock.com and/or exercises on app.wohuimandarin.com.',
  sso_join_campus_text4:
    'It will also allow those teachers to view your answers so they can give you targeted feedback. ',
  join: 'Join',
  spc_welcome: 'Welcome to your free',
  hsk_level_test: 'HSK Level Test',
  spc_mobile_desc:
    'To get started, please switch to a <strong>desk/laptop computer</strong> or else download our <strong>mobile app for phone and tablet.</strong>',
  free_practice_title: 'Free practice',
  choose_free_practice: 'Choose a practice method',
  word_flashcards: 'Word flashcards',
  word_practice: 'Word practice',
  analyse_text: 'Analyse a text',
  flashcards_title: 'Flashcards',
  practice_exercises_title: 'Practice Exercises',
  analyse_title: 'Analyse',
  practice_result_title: 'Practice Result',
  generate_flashcards: 'Generate a set of flashcards',
  generate_practice: 'Generate a set of practice questions',
  random_select: 'Auto Selection',
  manual_select: 'Manual Selection',
  max_words: 'Max {number} words',
  already_choose: 'Selected: {total}',
  free_practice_words_quantifier: 'words',
  // 产品确认错误提示
  free_practice_unchoose_question:
    'please select the question type, and cannot select all of them consecutively',
  free_practice_unchoose_practice: 'Please select a practice question type.',
  none_mark_words_hint: 'Non-bookmarked words',
  excceed_max_count: 'Max ({total}) words exceeded',
  free_practice_sound: 'Sound',
  free_practice_question: 'Question',
  free_practice_choose_exercise: 'Choose the style of exercise(s)',
  free_practice_exercise_select: 'Select 1',
  free_practice_exercise_Pairs: 'Pairs',
  free_practice_exercise_TF: 'Select T/F',
  launch: 'Launch',
  free_practice_check_text: 'Did you get it right?',
  free_practice_timer_pause: 'TIMER PAUSED',
  free_practice_timer_pause_desc:
    'The timer is automatically paused if no activity is detected for',
  free_practice_seconds: '{number} seconds',
  resume: 'RESUME',
  flashcard_completed: 'Flashcards Completed',
  practice_completed: 'Practice Completed',
  practice_spent_minutes: 'Time spent: {duration} minutes',
  practice_result_summary: 'Result Summary',
  practice_result_progress_txt: 'You got',
  practice_wrong: 'Wrong',
  practice_skip: 'Skipped',
  practice_done: 'Done',
  analyse_desc_1: 'Analyse a text for selected vocabulary',
  analyse_desc_2: 'Paste or type in a text in Chinese characters （max. {maxCount} characters）',
  analyse_input_placeholder: 'Input a text in Chinese characters',
  free_practice_need_word: 'Select vocabulary from the table or choose auto-select',
  free_practice_exercise_select_title: 'Select the correct answer',
  free_practice_exercise_pairs_title: 'Click to connect the matching pairs',
  free_practice_exercise_meaning_title: 'should be translated as',
  free_practice_exercise_sound_title: 'should be pronounced as',
  free_practice_exercise_characters_title: 'should be written as',
  free_practice_show_correct_answers: 'show correct answer',
  free_practice_show_my_answers: 'Show my answers',
  free_practice_check: 'Check',
  free_practice_correct: 'Correct',
  free_practice_characters: 'Characters',
  hsk_introduce_objective_questions: 'Objective questions',
  hsk_introduce_subjective_questions: 'Subjective questions',
  hsk_input_type_here: 'type here',
  hsk_translation_part_title: 'Translation: Part {count}',
  hsk_speaking_part_title: 'Speaking: Part {count}',
  subjective_reading_placeholder: 'Please answer the questions based on the article above ...',
  hsk_write_by_artical: 'Please write an essay based on the material above ...',
  hsk_translation_by_artical: 'Please translate based on the material above...',
  hsk_trasnlation_choose_language: 'Next is the translation section.  Please select your language.',
  choose_speaker: 'Select a speaker.',
  choose_microphone: 'Select a microphone.',
  hsk_is_recording: 'Recording in progress.',
  dialogue_speaking:
    'The last section is the speaking section. Please ensure that the speakers and microphone on your device are working properly.',
  start_recording: 'Click to start recording',
  hsk_write_count: 'Characters',
  error_access_media: 'Error accessing media devices.',
  setSinkId_not_supported: '{setSinkId} is not supported in your browser.',
  error_switch_device: 'Error switching device.',
  translation_section: 'Translation section',
  speaking_section: 'Speaking section',
  failed_upload_record: 'The audio upload failed, please click to upload again.',
  hsk_enter_next_segment_write_high:
    "Do you want to submit your writing? This will end the writing section, and you won't be able to go back and make any further changes.",
  hsk_enter_next_segment_translate_tip: '{count} translation questions have not yet been answered.',
  hsk_enter_next_segment_translate:
    "Do you want to submit your translations? This will end the translation section, and you won't be able to go back and make any further changes.",
  hsk_enter_next_segment_speaking_tip: '{count} speaking questions have not yet been answered.',
  // speaking & Traduction
  Speaking: 'Speaking',
  Translating: 'Translating',
  back_to_home: 'Back to home',
  about_us_desc: '<b>HSK Mock</b> is the official platform for realistic HSK, HSK Speaking, and YCT exam practice. Designed to mirror the real test experience, our goal is to help learners build confidence, track their progress, and get exam-ready with trusted tools and reliable scoring systems.',
  who_we_are: 'Who We Are',
  who_we_are_desc: 'HSK Mock is brought to you by <b>Chinese Testing International</b> — the official body behind the HSK and YCT exams — and <b>Wo Hui Mandarin</b>, a trusted name in Chinese language education. Together, we bring you a trusted platform designed to support learners worldwide with official mock exams and practice tools.',
  why_choose_hsk_mock: 'Why Choose HSK Mock?',
  about_us_carousel_1: 'Official HSK & YCT Mock Exams',
  about_us_carousel_1_content: 'Our mock exams follow the official structure and format of HSK, HSK Speaking, and YCT exams. Practice with confidence, knowing every test is aligned with the real exam.',
  about_us_carousel_2: 'Accurate Scoring Based on Official Standards',
  about_us_carousel_2_content: 'Receive results calculated using the same scoring criteria as Chinese Testing International. Our system ensures your scores reflect your actual test performance — so you know exactly where you stand.',
  about_us_carousel_3: 'Practice Tools for Smart Learning',
  about_us_carousel_3_content: 'Prepare with level-specific mock tests and interactive tools like vocabulary exercises and listening/reading drills to sharpen your skills.',
  about_us_carousel_4: 'Flexible Access on Any Device',
  about_us_carousel_4_content: 'Study anytime, anywhere. HSK Mock works on desktop and mobile so you can practise on your schedule — no matter where you are.',
  about_us_carousel_5: 'Used by Learners Worldwide',
  about_us_carousel_5_content: 'Trusted by students and schools around the globe, HSK Mock helps thousands of users improve their test performance and reach their language goals.',

  for_teachers_banner_title: 'Official Mandarin Assessment <br /> for Schools & Global Teams',
  for_teachers_banner_desc: 'Assess Chinese proficiency online with HSK Mock, the official platform for realistic HSK and YCT mock exams.<br /> Trusted by international schools, universities, HR teams, and global mobility managers.',
  for_teachers_banner_btn: 'Book a Demo',

  for_schools: 'For Schools & Educators',
  for_schools_desc: 'Prepare students confidently with official-style HSK & YCT mock exams.',
  for_schools_list_1: 'Teach real exam structure, timing & vocabulary',
  for_schools_list_2: 'Assign mock exams remotely or in class',
  for_schools_list_3: 'Instant scoring for HSK levels 1-3、YCT1-4',
  for_schools_list_4: 'Track individual & class progress over time',

  for_corporates: 'For Corporations & HR Teams',
  for_corporates_desc: 'Fast, flexible Mandarin assessments for relocation, hiring, and business needs.',
  for_corporates_list_1: 'Pre-relocation language screening & internal benchmarking',
  for_corporates_list_2: 'Instant HSK 1-3results; 48h results for advanced levels',
  for_corporates_list_3: 'Track improvement post-training',
  for_corporates_list_4: 'Anytime, anywhere – no test centres',

  official_format: 'Official Format',
  official_format_desc: 'Mirrors real HSK & YCT exams for accurate preparation.',
  smart_scoring: 'Smart Scoring',
  smart_scoring_desc: 'Based on official standards.',
  progress_analytics: 'Progress Analytics',
  progress_analytics_desc: 'Track performance by student or team, with detailed breakdowns.',
  remote_access: 'Remote Access',
  remote_access_desc: 'Fully web-based. Use anytime, anywhere – no test centres.',

  why_use_hsk: 'Who Uses HSK Mock?',
  international_schools: 'K12 Schools',
  international_schools_desc: 'Deliver HSK/YCT-ready mandarin programs with scalable assessments.',
  universities_institutes: 'Universities & Institutes',
  universities_institutes_desc: 'Support academic Mandarin tracks with official-style testing.',
  global_corporates: 'Global Corporates',
  global_corporates_desc: 'Benchmark and monitor employee proficiency for China-facing roles.',
  language_training_providers: 'Language Training Providers',
  language_training_providers_desc: 'Offer realistic, standards-aligned mock exams to learners.',

  ready_to_access: 'Ready to Assess Mandarin Skills with HSK Mock?',
  book_live_demo: "Book a live demo to explore a sample test, see the results dashboard, and learn about the easy onboarding process.",
  book_demo: 'Book a Demo',


  institutional_title: 'Mandarin Proficiency Assessment for Institutions',
  institutional_desc: 'HSK Mock provides online Mandarin assessments aligned with official HSK and YCT exam formats. Used by schools, universities and organisations to evaluate language proficiency and monitor progress.',
  institutional_btn: 'View Institutional Solutions',
  institutional_schools_title: 'Schools and Educators',
  institutional_schools_desc: 'Prepare students for HSK and YCT examinations using official mock exams.',
  institutional_corp_title: 'Corporations and HR Teams',
  institutional_corp_desc: 'Assess Mandarin proficiency for hiring, relocation or training programmes.',


  confidence_card0_detail_desc: 'Take a short placement test and get your recommended HSK level.',
  confidence_card0_detail_btn: 'Free placement test',
  confidence_choose_level: 'Choose your level',
  confidence_card1_detail_btn: 'Continue',
  confidence_choose_method: 'Choose a practice method',

  // ==================== New score report (newhsk1-6) ====================
  // ⚠️ 这批英文是随 i18n 抽取一并补的**兜底译文**，尚未经翻译同学校对。
  //
  // 为什么必须有：locales/index.js 的 fallbackLocale 是 'en'，且
  // silentTranslationWarn 为 true。en 缺失时，全部 14 种非中文语言都会把
  // key 名原样渲染到页面上（"nr_section_overview"），且控制台没有任何警告。
  // 有了这份 en，其余语言在译文回来之前至少回退到英文。
  //
  // 送翻译时请连同这份一起校对。占位符 {n} / {name} / {price} 必须保留。

  // -------- Section headings --------
  nr_section_overview: 'Score Overview',
  nr_section_overview_aside: 'By test structure',
  nr_section_answer: 'Answer Details',
  nr_section_answer_aside: 'Green indicates correct; red indicates incorrect',
  nr_section_analysis: 'Performance Analysis',
  nr_section_analysis_desc:
    'See where most points were lost on this test and which sections you performed better in.',
  nr_section_diagnosis: 'Learning Diagnosis',
  nr_section_next: 'Next Study Recommendations',
  nr_section_next_aside:
    'Generated based on topics, language tasks, words and characters, and knowledge mastery',

  // -------- Header --------
  nr_head_title: '{name} Score Report',
  nr_head_result_title: 'Test Results',
  nr_head_unmarked_wait: 'Grading is still in progress. Please wait.',
  nr_head_no_report:
    'There are no valid responses for this test yet, so we can’t analyze your knowledge or performance. Complete some questions, then check your score analysis again.',
  nr_head_unmarked_default:
    'The Writing section is not yet included in your total score. It will be graded by a professional rater. Once grading is complete, your total score will be updated and we’ll notify you by email.',
  nr_head_loading: 'Loading your test assessment. Please wait...',
  nr_head_loading_timeout: 'The assessment could not be generated. Please try again later.',
  // Certificate button reuses the existing key get_official_mock_certificate
  // Price: the API returns { currency, amount }; assembled into display text here
  nr_price: '{currency}{amount}',

  // -------- Score overview --------
  nr_overview_rate: 'Score: {n}%',
  // ⚠️⚠️ The nr_seg_* and nr_qtype_* keys below (52 in total) are built at
  // runtime: $t('nr_seg_' + code) / $t('nr_qtype_' + questionType).
  // Searching the codebase for these key literals finds nothing.
  //
  // **Do NOT run "remove unused i18n keys" tooling over them** — they would all
  // be deleted, and the segment names, answer-detail part titles and question
  // type names would silently render as empty strings.
  // Translators: these 52 keys all need translating despite appearing unused.
  nr_seg_listen: 'Listening',
  nr_seg_read: 'Reading',
  nr_seg_write: 'Writing',
  nr_seg_translation: 'Translation',
  nr_seg_speaking: 'Speaking',
  nr_part_name: 'Part {n}',
  nr_seg_part: '{seg} · {part}',
  nr_head_cert_hint_fail: 'Not passed. Available for download once you pass.',

  // -------- Question types --------
  // key = normalized questionType, i.e. {level}_{segment}_{partCode}.
  // The API returns new_hsk2_listen_1 (no type code); mixins/localizedName.js
  // normalizes both forms to the same key. Falls back to the segment name
  // when a type is missing here.
  nr_qtype_new_hsk1_listen_1: 'Listening: Choose the Picture',
  nr_qtype_new_hsk1_listen_2: 'Listening: Choose the Text',
  nr_qtype_new_hsk1_listen_3: 'Listening: Match the Pictures',
  nr_qtype_new_hsk1_listen_4: 'Listening Comprehension',
  nr_qtype_new_hsk1_read_1: 'Match Sentences to Pictures',
  nr_qtype_new_hsk1_read_2: 'Information Matching',
  nr_qtype_new_hsk1_read_3: 'Fill in the Blanks with the Correct Words',
  nr_qtype_new_hsk1_read_4: 'Reading Comprehension',
  nr_qtype_new_hsk2_listen_1: 'Listening: Choose the Picture',
  nr_qtype_new_hsk2_listen_2: 'Listening: Match the Pictures',
  nr_qtype_new_hsk2_listen_3: 'Listening Comprehension',
  nr_qtype_new_hsk2_read_1: 'Match Sentences to Pictures',
  nr_qtype_new_hsk2_read_2: 'Fill in the Blanks with the Correct Words',
  nr_qtype_new_hsk2_read_3: 'Information Matching',
  nr_qtype_new_hsk2_read_4: 'Reading Comprehension',
  nr_qtype_new_hsk2_write_1: 'Choose Chinese Character Components',
  nr_qtype_new_hsk2_write_2: 'Write Chinese Characters from Pinyin',
  nr_qtype_new_hsk3_listen_1: 'Listening: Match the Pictures',
  nr_qtype_new_hsk3_listen_2: 'Listening Comprehension',
  nr_qtype_new_hsk3_listen_3: 'Listening Comprehension',
  nr_qtype_new_hsk3_read_1: 'Information Matching',
  nr_qtype_new_hsk3_read_2: 'Fill in the Blanks with the Correct Words',
  nr_qtype_new_hsk3_read_3: 'Reading Comprehension',
  nr_qtype_new_hsk3_write_1: 'Write Chinese Characters from Pinyin',
  nr_qtype_new_hsk3_write_2: 'Make Sentences from Pictures and Given Words',
  nr_qtype_new_hsk4_listen_1: 'Listening Comprehension',
  nr_qtype_new_hsk4_listen_2: 'Listening Comprehension',
  nr_qtype_new_hsk4_read_1: 'Fill in the Blanks with the Correct Words',
  nr_qtype_new_hsk4_read_2: 'Reading Comprehension',
  nr_qtype_new_hsk4_read_3: 'Fill in the Blanks with the Correct Sentences',
  nr_qtype_new_hsk4_write_1: 'Make Sentences from Pictures and Given Words',
  nr_qtype_new_hsk4_write_2: 'Short-Text Writing',
  nr_qtype_new_hsk5_listen_1: 'Listening Comprehension',
  nr_qtype_new_hsk5_listen_2: 'Listening Comprehension',
  nr_qtype_new_hsk5_read_1: 'Fill in the Blanks with the Correct Words',
  nr_qtype_new_hsk5_read_2: 'Order the Paragraphs',
  nr_qtype_new_hsk5_read_3: 'Reading Comprehension',
  nr_qtype_new_hsk5_write_1: 'Picture-Sequence Writing',
  nr_qtype_new_hsk5_write_2: 'Topic-Based Writing',
  nr_qtype_new_hsk6_listen_1: 'Choose the Statement Matching the Audio',
  nr_qtype_new_hsk6_listen_2: 'Listening Comprehension',
  nr_qtype_new_hsk6_listen_3: 'Listening Comprehension',
  nr_qtype_new_hsk6_read_1: 'Fill in the Blanks with the Correct Words',
  nr_qtype_new_hsk6_read_2: 'Fill in the Blanks with the Correct Sentences',
  nr_qtype_new_hsk6_read_3: 'Reading Comprehension',
  nr_qtype_new_hsk6_write_1: 'Practical Writing',
  nr_qtype_new_hsk6_write_2: 'Topic-Based Writing',

  // -------- What to study next --------
  nr_next_topic_text:
    'This test included {total} questions on “{name}”. You answered {wrong} incorrectly, for an accuracy of {rate}%. We recommend reviewing this topic further.',
  nr_next_task_text:
    'This test included {total} questions on “{name}”. You answered {wrong} incorrectly, for an accuracy of {rate}%. We recommend continuing to practice with related questions.',
  nr_next_words_text:
    'You lost points on words/characters such as “{words}” in this test. Prioritize reviewing their meanings, usage, and contexts.',
  nr_next_grammar_text:
    'In this test, there were {total} questions related to “{name}”. You answered {wrong} of them incorrectly, for an accuracy of {rate}%. We recommend reviewing the basic usage of “{content}” and practicing with relevant example sentences.',
  nr_next_words_separator: ', ',

  // -------- Answer details --------
  nr_answer_accuracy: 'Accuracy: {n}%',
  nr_answer_more: 'View all answer details ({n})',

  // -------- Score analysis --------
  nr_analysis_overall: 'Overall Performance',
  // Built on the frontend from overallData. Note: no square brackets here —
  // the backend's own English string wrapped values in [ ], which reads like
  // unreplaced placeholders.
  nr_analysis_overall_pass:
    'Your total score on this test is 【{score}】, which 【meets the passing standard for HSK Level {level}】. You performed relatively well in 【{best}】, while 【{worst}】 is the area that currently needs the most improvement. We recommend prioritizing 【{worst}】 while maintaining your strengths.',
  nr_analysis_overall_fail:
    'Your total score on this test is 【{score}】, which 【does not meet the passing standard for HSK Level {level}】. You performed relatively well in 【{best}】, while 【{worst}】 is the area that currently needs the most improvement. We recommend prioritizing 【{worst}】 while maintaining your strengths.',
  nr_analysis_overall_zero:
    'Your total score on this test is 【0】, which 【does not meet the passing standard for HSK Level {level}】. All sections currently need significant improvement. We recommend reviewing the basics first, then gradually moving on to targeted practice.',
  nr_analysis_overall_full:
    'Your total score on this test is 【{score}】, which 【meets the passing standard for HSK Level {level}】. You performed well across all sections, and no area currently requires priority improvement. We recommend maintaining your current study progress.',
  nr_analysis_overall_pass_nolevel:
    'Your total score on this test is 【{score}】, which 【meets】 the passing standard. You performed relatively well in 【{best}】, while 【{worst}】 is the area that currently needs the most improvement. We recommend prioritizing 【{worst}】 while maintaining your strengths.',
  nr_analysis_overall_fail_nolevel:
    'Your total score on this test is 【{score}】, which 【does not meet】 the passing standard. You performed relatively well in 【{best}】, while 【{worst}】 is the area that currently needs the most improvement. We recommend prioritizing 【{worst}】 while maintaining your strengths.',
  nr_analysis_loss_title: 'Most of the {n} points lost came from',
  nr_analysis_loss_title_plain: 'Most points were lost in',
  nr_analysis_score: '{n} points',
  nr_analysis_percent: '{n}% of points lost',
  // Row labels for the strengths / weaknesses lists: subject + part.
  // Kept separate from nr_seg_* on purpose — the same segmentCode reads
  // differently in the answer-detail section.
  // Ordinals are whole entries: Chinese is 第一部分, English is Part 1.
  nr_subject_listen: 'Listening',
  nr_subject_read: 'Reading',
  nr_subject_write: 'Writing',
  nr_subject_translation: 'Translation',
  nr_subject_speaking: 'Speaking',
  nr_part_ordinal_1: 'Part 1',
  nr_part_ordinal_2: 'Part 2',
  nr_part_ordinal_3: 'Part 3',
  nr_part_ordinal_4: 'Part 4',
  nr_part_ordinal_5: 'Part 5',
  nr_analysis_row_name: '{subject}{part}',

  nr_analysis_strength: 'Stronger Areas',
  nr_analysis_strength_tag: 'Strength',
  nr_analysis_weakness: 'Areas Affecting Your Score Most',
  nr_analysis_weakness_tag: 'Priority',

  // -------- Learning diagnosis --------
  nr_diag_summary_title: 'Learning Performance Overview',
  nr_diag_summary_tag_good: '{name}: Good performance',
  nr_diag_summary_tag_weak: '{name}: Needs improvement',
  nr_diag_summary_tag_words: '{name}: Focused review recommended',
  nr_diag_topics_title: 'Topic Mastery',
  nr_diag_topics_aside: 'Grouped by performance range and accuracy',
  nr_diag_topics_more: 'View more topics ({n})',
  // 语法点掌握：按听力 / 阅读 / 写作分项，一个分项一张卡
  nr_diag_grammars_title: 'Grammar Mastery',
  nr_diag_grammars_aside:
    'See how you performed on grammar questions in Listening and Reading, and how you used grammar in Writing.',
  nr_diag_grammar_summary_label: 'Performance Summary',
  nr_diag_col_grammar: 'Grammar Point',
  nr_diag_grammars_more: 'View More Grammar Points ({n})',
  nr_diag_tasks_title: 'Language Task Mastery',
  nr_diag_tasks_aside: 'Based on your performance on communication tasks in this test',
  nr_diag_tasks_more: 'View more tasks ({n})',
  nr_diag_col_task: 'Language Task',
  nr_diag_col_count: 'Questions',
  nr_diag_col_accuracy: 'Accuracy',
  nr_diag_col_verdict: 'Performance',
  nr_diag_words_title: 'Words and Characters Not Yet Mastered',
  nr_diag_words_total: '{n} words/characters total',
  nr_diag_word_wrong_count: 'Related questions missed: {n}',
  nr_diag_word_tag: 'Not Yet Mastered',
  nr_diag_words_more: 'View more words/characters ({n})',
  nr_diag_stats_title: 'Word & Character Statistics',
  nr_diag_stat_involved: 'Words/Characters Covered',
  nr_diag_stat_unstable: 'Not Yet Mastered',
  nr_diag_stat_accuracy: 'Word/Character Accuracy',
  nr_diag_stat_involved_note: 'This test covered {n} words/characters',
  nr_diag_stat_unstable_note:
    '{n} words/characters accounted for significant point losses in this test',
  nr_diag_stat_accuracy_note: 'Calculated from the words/characters covered in this test',
  nr_diag_stats_footnote:
    'The statistics above are based only on the words and characters covered in this test and do not represent your overall mastery of all words and characters at this level.',
  // The "this attempt" tag text is not defined here — it comes straight from
  // diagnosis.tasks[].masteryDesc; the front end only picks the colour.
  nr_diag_question_count: '{n} questions',
  nr_diag_question_correct: '{n} correct',
  nr_diag_question_total: '{n} questions total',

  // -------- Paywall banner --------
  nr_banner_free_title: 'Learning Diagnosis Report Free for a Limited Time',
  nr_banner_free_desc:
    'You can currently view the full score analysis, learning diagnosis, and next-step study recommendations for free.',
  nr_banner_owned_title: 'Full Learning Diagnosis Unlocked',
  nr_banner_owned_desc:
    'View the full score analysis, learning diagnosis, and next-step study recommendations.',
  nr_banner_paywall_title: 'Full Learning Diagnosis Is a Paid Feature',
  nr_banner_paywall_desc:
    'View test results and answer details for free. Unlock to see the full analysis and study recommendations.',

  // -------- Unlock card --------
  nr_unlock_tag: 'Full Report Locked',
  nr_unlock_title: 'Unlock Full Score Analysis & Learning Diagnosis',
  nr_unlock_desc:
    'See where you lost points, your topic mastery, language task performance, word and character mastery, knowledge mastery, and next study recommendations.',
  nr_unlock_btn: 'Unlock Full Report for {price}',
  nr_unlock_btn_plain: 'Unlock Full Report',
  nr_unlock_footnote: 'Purchase to view the full report for this test.',

  // -------- Common --------
  nr_common_retry: 'Retry',
  nr_common_collapse: 'Collapse',

  // -------- Errors --------
  nr_err_load_failed: 'Failed to load the score report. Please try again later.',
  nr_err_scene_unsupported: 'The new score report is not currently available for this test type.',
  nr_err_level_mismatch: 'This score report isn’t available for this test type.',
  nr_err_no_credit: 'You’ve used all available attempts for this mock test.',
  nr_err_retake_network: 'Network error. Please try again.',
  nr_err_retake_failed: 'Unable to start the test right now. Please try again later.',
  nr_err_question_not_found:
    'There’s an issue with the question data. Please download the test again.',
  nr_err_view_question_failed: 'Unable to view this question right now. Please try again later.',
  nr_err_common: 'Operation failed. Please try again later.',
  nr_err_pay_failed: 'Unable to start payment. Please try again later.',
  nr_err_pay_closed: 'This order has been closed. Please start a new payment.',
  nr_err_pay_timeout:
    'Payment confirmation is in progress. If you’ve completed the payment, refresh the page to check the result.',
  // 首页改版（2026-09 原型）新增词条
  home_v2_hero_kicker: 'Official Online HSK Mock Test Platform',
  home_v2_hero_title_1: 'Take an Official',
  home_v2_hero_title_2: 'HSK Mock Test Online',
  home_v2_hero_desc: 'Test your Chinese proficiency with real HSK exam questions, real test timing and HSK aligned scoring.',
  home_v2_hero_image_alt: 'HSK Mock platform displayed on a desktop computer in a warm modern home office',
  home_v2_choose_your_exam: 'Choose Your Exam',
  home_v2_proof_cti_title: 'Developed with Chinese Testing International',
  home_v2_proof_cti_desc: 'The organisation behind the HSK exam.',
  home_v2_proof_learners_title: 'Learners worldwide',
  home_v2_proof_learners_desc: 'Preparing for HSK with HSK Mock.',
  home_v2_proof_authentic_title: 'Authentic past exam content',
  home_v2_proof_authentic_desc: 'Real question types, structure and scoring.',
  home_v2_ai_badge: 'New',
  home_v2_ai_title: 'See Where You Can Improve Before Test Day',
  home_v2_ai_desc: 'The AI Score Report turns your New HSK mock test into clear insights you can use for your next study session.',
  home_v2_ai_slide1_a: 'Score',
  home_v2_ai_slide1_b: 'Overview',
  home_v2_ai_slide2_a: 'Topic, Grammar,',
  home_v2_ai_slide2_b: 'Language Task Mastery',
  home_v2_ai_slide3_a: 'Words, Characters',
  home_v2_ai_slide3_b: 'to Review',
  home_v2_ai_slide4_a: 'Next Study',
  home_v2_ai_slide4_b: 'Recommendations',
  home_v2_ai_cta: 'Explore New HSK Mock Tests',
  home_v2_ai_note: 'Only available with New HSK mock tests.',
  home_v2_testimonials_title: 'What Learners Achieved with HSK Mock',
  home_v2_testimonials_desc: 'Real preparation experiences and measurable exam results.',
  home_v2_experience_title: 'Practise the HSK Online',
  home_v2_exp1_a: 'Real Test',
  home_v2_exp1_b: 'Interface',
  home_v2_exp1_desc: 'Take a full mock test with real HSK structure, timing and authentic past exam content.',
  home_v2_exp1_alt: 'HSK Mock real test interface',
  home_v2_exp2_a: 'HSK Aligned',
  home_v2_exp2_b: 'Scoring',
  home_v2_exp2_desc: 'See your result clearly after the test, with scoring aligned to HSK standards.',
  home_v2_exp2_alt: 'HSK Mock scoring results',
  home_v2_exp3_a: 'Improve Your',
  home_v2_exp3_b: 'Vocabulary',
  home_v2_exp3_desc: 'Review the words and characters that need more attention before your next attempt.',
  home_v2_exp3_alt: 'HSK Mock vocabulary review',
  home_v2_b2b_title: 'HSK Mock for Schools and Institutions',
  home_v2_b2b_lead: 'Give your learners HSK and YCT mock tests online. Review completion and scores in one place, and see where more preparation is needed.',
  home_v2_b2b_point1: 'Choose tests by exam and level',
  home_v2_b2b_point2: 'See completion and scores',
  home_v2_b2b_point3: 'Spot where learners need more practice',
  home_v2_b2b_cta: 'Talk to Our Education Team',
  home_v2_b2b_image_alt: 'Students taking HSK Mock tests online in a classroom',
  home_v2_app_label: 'HSK Mock mobile app',
  home_v2_app_title: 'Continue Your Preparation Wherever You Study',
  home_v2_app_desc: 'Switch between desktop and mobile with the same account to take mock tests and review your results wherever you study.',
  home_v2_app_store_pre: 'Download on the',
  home_v2_app_store_aria: 'Download HSK Mock on the App Store',
  home_v2_google_play_pre: 'Get it on',
  home_v2_google_play_aria: 'Get HSK Mock on Google Play',
  home_v2_app_learner_alt: 'Learner preparing for HSK on a laptop',
  home_v2_app_phone_alt: 'HSK Mock mobile app shown on a phone',
  home_v2_help_title: 'Need Help?',
  home_v2_help_faq: 'FAQ',
  home_v2_help_faq_desc: 'Find answers to the most common questions about HSK preparation and our platform.',
  home_v2_help_faq_link: 'Browse FAQs',
  home_v2_help_contact: 'Contact',
  home_v2_help_contact_desc: 'Need personalised help? Get in touch with our support team for any questions or concerns.',
  home_v2_help_contact_link: 'Contact Us',
  home_v2_help_bubble: 'Need help?',
  home_v2_help_mascot_alt: 'HSK Mock panda mascot',
  // 等级选择页改版（2026-09 原型）新增词条
  choose_v2_intro: 'Select the exam you are preparing for, then choose your level.',
  choose_v2_back: 'Back to homepage',
  choose_v2_select_exam: 'Select Exam',
  choose_v2_choose_level: 'Choose Level',
  choose_v2_level_help: 'Not sure which level to choose?',
  choose_v2_level_help_link: 'Try the free level test',
  choose_v2_fact_questions: '{n} questions',
  choose_v2_fact_minutes: '{n} minutes',
  choose_v2_fact_minutes_about: 'About {n} minutes',
  choose_v2_fact_full_speaking: 'Complete speaking test',
  choose_v2_result_immediate: 'Results available immediately',
  choose_v2_result_48h: 'Results within 48 hours',
  choose_v2_result_before_purchase: 'Result timing shown before purchase',
  // 等级详情页改版（2026-09 原型）新增词条
  product_v2_back: 'Change exam or level',
  product_v2_badge_aria: 'Selected exam',
  product_v2_tabs_aria: 'Level navigation',
  product_v2_tab_tests: 'Tests',
  product_v2_tab_about: 'About',
  product_v2_tab_vocabulary: 'Vocabulary',
  product_v2_tab_free: 'Free Practice',
  product_v2_tab_resources: 'Resources',
  product_v2_tests_heading: '{level} Mock Tests',
  product_v2_single_price_aria: 'Price for one HSK Mock test',
  product_v2_single_test: 'Single test',
  product_v2_price_before_payment: 'Price shown before payment',
  product_v2_tests_guidance: 'Choose an HSK Mock test.',
  product_v2_status_ready: 'Ready',
  product_v2_status_progress: 'In progress',
  product_v2_status_complete: 'Completed',
  product_v2_use_code: 'Use a code',
  product_v2_bundle_heading: 'Save with Multi-Test Packs',
  product_v2_pack_tests: 'test | tests',
  product_v2_pack_saving: 'Save {n}',
  product_v2_pack_continue: 'Continue · {price}',
  product_v2_go_title_1: 'Get official HSK 1 or 2',
  product_v2_go_title_2: '',
  product_v2_go_desc_1: 'Learn at your level with HSK 1–3 courses.',
  product_v2_go_desc_2: 'certification in the app.',
  product_v2_go_apple_aria: 'Download HSK GO on the App Store (opens in a new tab)',
  product_v2_go_google_aria: 'Get HSK GO on Google Play (opens in a new tab)',
  product_v2_go_site_aria: 'Visit the HSK GO website (opens in a new tab)',
  checkout_back_purchase: 'Back to Purchase',
  checkout_title: 'Checkout',
  checkout_subtitle_oversea: 'Review your order details before proceeding to payment.',
  checkout_subtitle_china: 'Review your order details and select a payment method.',
  checkout_order_info: 'Order Details',
  checkout_level: 'Level',
  checkout_unit_price: 'Unit Price',
  checkout_vat_included: 'VAT included',
  checkout_quantity: 'Quantity',
  checkout_amount_due: 'Total Due',
  checkout_vat_note: 'All prices include VAT.',
  checkout_pay_method: 'Select Payment Method',
  checkout_alipay: 'Alipay',
  checkout_back: 'Back',
  checkout_confirm: 'Confirm Payment',
  checkout_secure: 'Secure payments · Multiple payment methods',
  product_v2_auth_purchase_title: 'Continue to buy this test',
  product_v2_auth_purchase_intro: 'Your HSK Mock test will be added to the account you choose after payment.',
  product_v2_auth_purchase_login: 'Log in, review the order and continue to payment.',
  product_v2_auth_purchase_signup: 'Create and verify an account before payment.',
  product_v2_auth_redeem_title: 'Sign in to use your test code',
  product_v2_auth_redeem_intro: 'Your code will add this HSK Mock test to the account you choose.',
  product_v2_auth_redeem_login: 'Log in and add the test to your account.',
  product_v2_auth_redeem_signup: 'Create and verify an account, then add the test.',
  product_v2_auth_have_account: 'Already have an account?',
  product_v2_auth_new: 'New to HSK Mock?',
  product_v2_auth_login: 'Log In',
  product_v2_auth_signup: 'Create Account',
  // 修改密码新规则（2026-09-30）新增词条
  password_invalid_chars: 'Password cannot contain spaces or invalid characters',
  password_length_tip: 'Password must be 8–20 characters long',
}
